import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=e5172d78&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=e5172d78&prod&lang=css"
import style1 from "./OrderDetail.vue?vue&type=style&index=1&id=e5172d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5172d78",
  null
  
)

export default component.exports